/* eslint-disable no-new-object */

import * as Constants from "utils/Constants";

import { EMAIL_DESIGNER } from "redux/constants/action-types";
import HelperFunctions from "utils/HelperFunctions";
import Moment from 'moment';
import authService from "../../../components/api-authorization/AuthorizeService";
import axios from "axios";
import { downloadFileV2 } from "redux/actions/Common/Common";

export function BEEAuth(clientId, isBEEPageAuth = false) {
  return async function (dispatch) {
    try {
      let URL = `${Constants.VNEXT_BASE_URL}ESP/Bee/Auth?clientId=${clientId}&isBeePageAuth=${isBEEPageAuth}`;

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.BEE_AUTH,
        payload: JSON.parse(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getAbandonCartSpecialLinks(
  clientId,
  showAll = false,
  status = "Published"
) {
  return async function (dispatch) {
    try {
      let URL =
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
        "ESP/Design/GetAbandonCartSpecialLinks?clientId=" +
        clientId;

      const response = await axios.get(URL);
      dispatch({
        type: EMAIL_DESIGNER.ABANDON_CART_SPECIAL_LINKS,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getSurveySpecialLinks(clientId) {
  return async function (dispatch) {
    try {
      let URL =
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
        "ESP/Design/GetSurveySpecialLinks?clientId=" +
        clientId;

      const response = await axios.get(URL);
      dispatch({
        type: EMAIL_DESIGNER.SURVEY_SPECIAL_LINKS,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function sendAIGenerateDesignRequest(clientId, threadId, prompt) {
  return async function (dispatch) {
    try {
      dispatch({
        type: EMAIL_DESIGNER.AI_GENERATE_DESIGN_REQUEST_START,
      });

      const USE_MOCK_RESPONSE = false;

      if (USE_MOCK_RESPONSE) {
        await new Promise(resolve => setTimeout(resolve, 2000));
        
        dispatch({
          type: EMAIL_DESIGNER.AI_GENERATE_DESIGN_REQUEST_STAGE_2,
        });

        await new Promise(resolve => setTimeout(resolve, 3000));

        const mockResponse = {
          threadId: threadId || `mock-thread-${Date.now()}`,
          responseText: `Generated email design based on: "${prompt}"`,
          succeeded: true,
          designJsonSimple: JSON.stringify({
            page: {
              body: {
                rows: [
                  {
                    columns: [
                      {
                        modules: [
                          {
                            type: "mailup-bee-newsletter-modules-text",
                            descriptor: {
                              text: {
                                html: `<p>AI Generated Content: ${prompt}</p>`
                              }
                            }
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            }
          }),
          designJsonComplex: JSON.stringify({
    "page": {
        "title": "AI Generated Email",
        "description": `Generated based on: ${prompt}`,
        "template": {
            "name": "ai-generated-template",
            "type": "basic",
            "version": "2.0.0"
        },
        "body": {
            "type": "mailup-bee-page-proprerties",
            "container": {
                "style": {
                    "background-color": "#FFFFFF"
                }
            },
            "content": {
                "computedStyle": {
                    "align": "center",
                    "linkColor": "#7DF9FF",
                    "messageBackgroundColor": "#FFFFFF",
                    "messageWidth": "600px"
                },
                "style": {
                    "color": "#000000",
                    "font-family": "Arial, Helvetica Neue, Helvetica, sans-serif"
                }
            },
            "webFonts": []
        },
        "rows": [
            {
                "columns": [
                    {
                        "grid-columns": 4,
                        "modules": [
                            {
                                "descriptor": {
                                    "computedStyle": {
                                        "class": "center autowidth"
                                    },
                                    "image": {
                                        "alt": "Company Logo",
                                        "href": "https://yourcompany.com",
                                        "prefix": "",
                                        "src": "https://example.com/logo.png",
                                        "target": "_blank"
                                    },
                                    "style": {
                                        "border-radius": "0px",
                                        "padding-bottom": "0px",
                                        "padding-left": "0px",
                                        "padding-right": "0px",
                                        "padding-top": "0px"
                                    }
                                },
                                "locked": false,
                                "type": "mailup-bee-newsletter-modules-image",
                                "uuid": "05eca512-42b5-421c-9a34-bc1853af179f"
                            }
                        ],
                        "style": {
                            "background-color": "transparent",
                            "border-bottom": "0 solid transparent",
                            "border-left": "0 solid transparent",
                            "border-right": "0 solid transparent",
                            "border-top": "0 solid transparent",
                            "padding-bottom": "5px",
                            "padding-left": "0px",
                            "padding-right": "0px",
                            "padding-top": "5px"
                        },
                        "uuid": "9b2ad83f-19af-4d35-a361-3b16c237800f"
                    },
                    {
                        "grid-columns": 8,
                        "modules": [
                            {
                                "descriptor": {
                                    "computedStyle": {
                                        "hideContentOnDesktop": false,
                                        "hideContentOnMobile": false
                                    },
                                    "heading": {
                                        "style": {
                                            "color": "#36454F",
                                            "direction": "ltr",
                                            "font-family": "inherit",
                                            "font-size": "28px",
                                            "font-weight": "700",
                                            "letter-spacing": "0px",
                                            "line-height": "120%",
                                            "link-color": "#7DF9FF",
                                            "text-align": "center"
                                        },
                                        "text": "The Future of Sound is Here",
                                        "title": "h1"
                                    },
                                    "style": {
                                        "padding-bottom": "10px",
                                        "padding-left": "0px",
                                        "padding-right": "0px",
                                        "padding-top": "10px",
                                        "text-align": "center",
                                        "width": "100%"
                                    }
                                },
                                "locked": false,
                                "type": "mailup-bee-newsletter-modules-heading",
                                "uuid": "938d8f15-b8e9-4b9e-99c1-9c70592957b6"
                            },
                            {
                                "descriptor": {
                                    "computedStyle": {
                                        "class": "center autowidth"
                                    },
                                    "image": {
                                        "alt": "Echo Buds Pro Lifestyle Image",
                                        "href": "",
                                        "prefix": "",
                                        "src": "https://example.com/echo-buds-pro-hero.jpg",
                                        "target": "_blank"
                                    },
                                    "style": {
                                        "border-radius": "0px",
                                        "padding-bottom": "0px",
                                        "padding-left": "0px",
                                        "padding-right": "0px",
                                        "padding-top": "0px"
                                    }
                                },
                                "locked": false,
                                "type": "mailup-bee-newsletter-modules-image",
                                "uuid": "31b8d443-0d91-4a9b-8399-a3a724e3ef76"
                            }
                        ],
                        "style": {
                            "background-color": "transparent",
                            "border-bottom": "0 solid transparent",
                            "border-left": "0 solid transparent",
                            "border-right": "0 solid transparent",
                            "border-top": "0 solid transparent",
                            "padding-bottom": "5px",
                            "padding-left": "0px",
                            "padding-right": "0px",
                            "padding-top": "5px"
                        },
                        "uuid": "e1fab6b7-434d-4c76-b8b6-27dc923a5586"
                    }
                ],
                "container": {
                    "style": {
                        "background-color": "#FFFFFF",
                        "background-image": "none",
                        "background-position": "top left",
                        "background-repeat": "no-repeat"
                    }
                },
                "content": {
                    "computedStyle": {
                        "hideContentOnDesktop": false,
                        "hideContentOnMobile": false,
                        "rowColStackOnMobile": true,
                        "rowReverseColStackOnMobile": false,
                        "verticalAlign": "top"
                    },
                    "style": {
                        "background-color": "#FFFFFF",
                        "background-image": "none",
                        "background-position": "top left",
                        "background-repeat": "no-repeat",
                        "color": "#000000",
                        "width": "500px"
                    }
                },
                "empty": false,
                "locked": false,
                "synced": false,
                "type": "",
                "uuid": "e126c9f1-d808-4fe2-a18b-4d581aa87812"
            },
            {
                "columns": [
                    {
                        "grid-columns": 4,
                        "modules": [
                            {
                                "descriptor": {
                                    "computedStyle": {
                                        "iconHeight": "32px",
                                        "iconSpacing": {
                                            "padding-bottom": "5px",
                                            "padding-left": "5px",
                                            "padding-right": "5px",
                                            "padding-top": "5px"
                                        },
                                        "itemsSpacing": "0px"
                                    },
                                    "iconsList": {
                                        "icons": [
                                            {
                                                "alt": "Battery Icon",
                                                "height": "48",
                                                "href": "",
                                                "id": "23bd17cb-9f54-4d0e-8ed9-515193ac3b3b",
                                                "image": "https://example.com/icons/battery.png",
                                                "target": "_self",
                                                "text": "",
                                                "textPosition": "top",
                                                "width": "48"
                                            }
                                        ]
                                    },
                                    "style": {
                                        "color": "#000000",
                                        "font-family": "inherit",
                                        "font-size": "14px",
                                        "font-weight": "400",
                                        "padding-bottom": "0",
                                        "padding-left": "0",
                                        "padding-right": "0",
                                        "padding-top": "0",
                                        "text-align": "center"
                                    }
                                },
                                "locked": false,
                                "type": "mailup-bee-newsletter-modules-icons",
                                "uuid": "842fc3b8-8c4a-4107-bad8-8ac4aa20638d"
                            },
                            {
                                "descriptor": {
                                    "computedStyle": {
                                        "hideContentOnDesktop": false,
                                        "hideContentOnMobile": false
                                    },
                                    "heading": {
                                        "style": {
                                            "color": "#36454F",
                                            "direction": "ltr",
                                            "font-family": "inherit",
                                            "font-size": "18px",
                                            "font-weight": "700",
                                            "letter-spacing": "0px",
                                            "line-height": "120%",
                                            "link-color": "#7DF9FF",
                                            "text-align": "center"
                                        },
                                        "text": "30-Hour Playtime",
                                        "title": "h3"
                                    },
                                    "style": {
                                        "padding-bottom": "0px",
                                        "padding-left": "0px",
                                        "padding-right": "0px",
                                        "padding-top": "0px",
                                        "text-align": "center",
                                        "width": "100%"
                                    }
                                },
                                "locked": false,
                                "type": "mailup-bee-newsletter-modules-heading",
                                "uuid": "f768e624-484b-4faf-9822-4d87ad0efd6f"
                            },
                            {
                                "descriptor": {
                                    "computedStyle": {
                                        "hideContentOnDesktop": false,
                                        "hideContentOnMobile": false
                                    },
                                    "paragraph": {
                                        "computedStyle": {
                                            "linkColor": "#7DF9FF",
                                            "paragraphSpacing": "16px"
                                        },
                                        "html": "Power through your entire day and more.",
                                        "style": {
                                            "color": "#36454F",
                                            "direction": "ltr",
                                            "font-family": "inherit",
                                            "font-size": "14px",
                                            "font-weight": "400",
                                            "letter-spacing": "0px",
                                            "line-height": "120%",
                                            "text-align": "center"
                                        }
                                    },
                                    "style": {
                                        "padding-bottom": "10px",
                                        "padding-left": "10px",
                                        "padding-right": "10px",
                                        "padding-top": "10px"
                                    }
                                },
                                "locked": false,
                                "type": "mailup-bee-newsletter-modules-paragraph",
                                "uuid": "d334a083-c20e-4549-9526-b2351a5eab70"
                            }
                        ],
                        "style": {
                            "background-color": "transparent",
                            "border-bottom": "0 solid transparent",
                            "border-left": "0 solid transparent",
                            "border-right": "0 solid transparent",
                            "border-top": "0 solid transparent",
                            "padding-bottom": "5px",
                            "padding-left": "0px",
                            "padding-right": "0px",
                            "padding-top": "5px"
                        },
                        "uuid": "5efcf0cb-1c0a-4f55-9a56-7c587ff754cd"
                    },
                    {
                        "grid-columns": 4,
                        "modules": [
                            {
                                "descriptor": {
                                    "computedStyle": {
                                        "iconHeight": "32px",
                                        "iconSpacing": {
                                            "padding-bottom": "5px",
                                            "padding-left": "5px",
                                            "padding-right": "5px",
                                            "padding-top": "5px"
                                        },
                                        "itemsSpacing": "0px"
                                    },
                                    "iconsList": {
                                        "icons": [
                                            {
                                                "alt": "Sound Wave Icon",
                                                "height": "48",
                                                "href": "",
                                                "id": "e8e85255-06b7-45f2-a62f-3b556a5937e9",
                                                "image": "https://example.com/icons/soundwave.png",
                                                "target": "_self",
                                                "text": "",
                                                "textPosition": "top",
                                                "width": "48"
                                            }
                                        ]
                                    },
                                    "style": {
                                        "color": "#000000",
                                        "font-family": "inherit",
                                        "font-size": "14px",
                                        "font-weight": "400",
                                        "padding-bottom": "0",
                                        "padding-left": "0",
                                        "padding-right": "0",
                                        "padding-top": "0",
                                        "text-align": "center"
                                    }
                                },
                                "locked": false,
                                "type": "mailup-bee-newsletter-modules-icons",
                                "uuid": "cff1bcc0-b354-477d-a509-8a32d99b6066"
                            },
                            {
                                "descriptor": {
                                    "computedStyle": {
                                        "hideContentOnDesktop": false,
                                        "hideContentOnMobile": false
                                    },
                                    "heading": {
                                        "style": {
                                            "color": "#36454F",
                                            "direction": "ltr",
                                            "font-family": "inherit",
                                            "font-size": "18px",
                                            "font-weight": "700",
                                            "letter-spacing": "0px",
                                            "line-height": "120%",
                                            "link-color": "#7DF9FF",
                                            "text-align": "center"
                                        },
                                        "text": "Active Noise-Cancelling",
                                        "title": "h3"
                                    },
                                    "style": {
                                        "padding-bottom": "0px",
                                        "padding-left": "0px",
                                        "padding-right": "0px",
                                        "padding-top": "0px",
                                        "text-align": "center",
                                        "width": "100%"
                                    }
                                },
                                "locked": false,
                                "type": "mailup-bee-newsletter-modules-heading",
                                "uuid": "6716c477-33d1-483b-93e7-312edbd573ab"
                            },
                            {
                                "descriptor": {
                                    "computedStyle": {
                                        "hideContentOnDesktop": false,
                                        "hideContentOnMobile": false
                                    },
                                    "paragraph": {
                                        "computedStyle": {
                                            "linkColor": "#7DF9FF",
                                            "paragraphSpacing": "16px"
                                        },
                                        "html": "Immerse yourself in pure, uninterrupted audio.",
                                        "style": {
                                            "color": "#36454F",
                                            "direction": "ltr",
                                            "font-family": "inherit",
                                            "font-size": "14px",
                                            "font-weight": "400",
                                            "letter-spacing": "0px",
                                            "line-height": "120%",
                                            "text-align": "center"
                                        }
                                    },
                                    "style": {
                                        "padding-bottom": "10px",
                                        "padding-left": "10px",
                                        "padding-right": "10px",
                                        "padding-top": "10px"
                                    }
                                },
                                "locked": false,
                                "type": "mailup-bee-newsletter-modules-paragraph",
                                "uuid": "a1d27389-5de2-466e-99ae-2f9c7f90dbca"
                            }
                        ],
                        "style": {
                            "background-color": "transparent",
                            "border-bottom": "0 solid transparent",
                            "border-left": "0 solid transparent",
                            "border-right": "0 solid transparent",
                            "border-top": "0 solid transparent",
                            "padding-bottom": "5px",
                            "padding-left": "0px",
                            "padding-right": "0px",
                            "padding-top": "5px"
                        },
                        "uuid": "e08d6b69-616c-4275-b8f5-9059e30fd956"
                    },
                    {
                        "grid-columns": 4,
                        "modules": [
                            {
                                "descriptor": {
                                    "computedStyle": {
                                        "iconHeight": "32px",
                                        "iconSpacing": {
                                            "padding-bottom": "5px",
                                            "padding-left": "5px",
                                            "padding-right": "5px",
                                            "padding-top": "5px"
                                        },
                                        "itemsSpacing": "0px"
                                    },
                                    "iconsList": {
                                        "icons": [
                                            {
                                                "alt": "Feather Icon",
                                                "height": "48",
                                                "href": "",
                                                "id": "44eb46df-0a17-49ff-a569-40e66eb5a1f1",
                                                "image": "https://example.com/icons/feather.png",
                                                "target": "_self",
                                                "text": "",
                                                "textPosition": "top",
                                                "width": "48"
                                            }
                                        ]
                                    },
                                    "style": {
                                        "color": "#000000",
                                        "font-family": "inherit",
                                        "font-size": "14px",
                                        "font-weight": "400",
                                        "padding-bottom": "0",
                                        "padding-left": "0",
                                        "padding-right": "0",
                                        "padding-top": "0",
                                        "text-align": "center"
                                    }
                                },
                                "locked": false,
                                "type": "mailup-bee-newsletter-modules-icons",
                                "uuid": "e1a4a3a0-c09e-41a6-bcad-b6807dfc62a5"
                            },
                            {
                                "descriptor": {
                                    "computedStyle": {
                                        "hideContentOnDesktop": false,
                                        "hideContentOnMobile": false
                                    },
                                    "heading": {
                                        "style": {
                                            "color": "#36454F",
                                            "direction": "ltr",
                                            "font-family": "inherit",
                                            "font-size": "18px",
                                            "font-weight": "700",
                                            "letter-spacing": "0px",
                                            "line-height": "120%",
                                            "link-color": "#7DF9FF",
                                            "text-align": "center"
                                        },
                                        "text": "Ergonomic & Lightweight",
                                        "title": "h3"
                                    },
                                    "style": {
                                        "padding-bottom": "0px",
                                        "padding-left": "0px",
                                        "padding-right": "0px",
                                        "padding-top": "0px",
                                        "text-align": "center",
                                        "width": "100%"
                                    }
                                },
                                "locked": false,
                                "type": "mailup-bee-newsletter-modules-heading",
                                "uuid": "13734eb1-3cff-49b3-a8ce-da55747dd4dc"
                            },
                            {
                                "descriptor": {
                                    "computedStyle": {
                                        "hideContentOnDesktop": false,
                                        "hideContentOnMobile": false
                                    },
                                    "paragraph": {
                                        "computedStyle": {
                                            "linkColor": "#7DF9FF",
                                            "paragraphSpacing": "16px"
                                        },
                                        "html": "Designed for all-day comfort you&#39;ll barely notice.",
                                        "style": {
                                            "color": "#36454F",
                                            "direction": "ltr",
                                            "font-family": "inherit",
                                            "font-size": "14px",
                                            "font-weight": "400",
                                            "letter-spacing": "0px",
                                            "line-height": "120%",
                                            "text-align": "center"
                                        }
                                    },
                                    "style": {
                                        "padding-bottom": "10px",
                                        "padding-left": "10px",
                                        "padding-right": "10px",
                                        "padding-top": "10px"
                                    }
                                },
                                "locked": false,
                                "type": "mailup-bee-newsletter-modules-paragraph",
                                "uuid": "7449c679-633f-472f-bc01-c854a6e9f539"
                            }
                        ],
                        "style": {
                            "background-color": "transparent",
                            "border-bottom": "0 solid transparent",
                            "border-left": "0 solid transparent",
                            "border-right": "0 solid transparent",
                            "border-top": "0 solid transparent",
                            "padding-bottom": "5px",
                            "padding-left": "0px",
                            "padding-right": "0px",
                            "padding-top": "5px"
                        },
                        "uuid": "303cf25b-ed13-4c45-b2c5-0ee0209d69b7"
                    }
                ],
                "container": {
                    "style": {
                        "background-color": "#FFFFFF",
                        "background-image": "none",
                        "background-position": "top left",
                        "background-repeat": "no-repeat"
                    }
                },
                "content": {
                    "computedStyle": {
                        "columnsSpacing": "10px",
                        "hideContentOnDesktop": false,
                        "hideContentOnMobile": false,
                        "rowColStackOnMobile": true,
                        "rowReverseColStackOnMobile": false,
                        "verticalAlign": "top"
                    },
                    "style": {
                        "background-color": "#FFFFFF",
                        "background-image": "none",
                        "background-position": "top left",
                        "background-repeat": "no-repeat",
                        "color": "#000000",
                        "width": "500px"
                    }
                },
                "empty": false,
                "locked": false,
                "synced": false,
                "type": "",
                "uuid": "42233fa2-bbff-4008-89e0-fed7728b6d6f"
            },
            {
                "columns": [
                    {
                        "grid-columns": 12,
                        "modules": [
                            {
                                "descriptor": {
                                    "computedStyle": {
                                        "hideContentOnDesktop": false,
                                        "hideContentOnMobile": false
                                    },
                                    "paragraph": {
                                        "computedStyle": {
                                            "linkColor": "#7DF9FF",
                                            "paragraphSpacing": "16px"
                                        },
                                        "html": "Be among the first to experience the Echo Buds Pro. Pre-order now and receive a free wireless charging case—a $50 value!",
                                        "style": {
                                            "color": "#36454F",
                                            "direction": "ltr",
                                            "font-family": "inherit",
                                            "font-size": "16px",
                                            "font-weight": "700",
                                            "letter-spacing": "0px",
                                            "line-height": "120%",
                                            "text-align": "center"
                                        }
                                    },
                                    "style": {
                                        "padding-bottom": "20px",
                                        "padding-left": "10px",
                                        "padding-right": "10px",
                                        "padding-top": "20px"
                                    }
                                },
                                "locked": false,
                                "type": "mailup-bee-newsletter-modules-paragraph",
                                "uuid": "419c4543-7115-45a2-ad9b-50cd8d47cb8b"
                            },
                            {
                                "descriptor": {
                                    "button": {
                                        "href": "https://yourcompany.com/echo-buds-pro",
                                        "label": "<div class=\"txtTinyMce-wrapper\" style=\"\" data-mce-style=\"\"><p style=\"word-break:break-word;\" data-mce-style=\"word-break:break-word;\">Pre-Order Now</p></div>",
                                        "style": {
                                            "background-color": "#7DF9FF",
                                            "border-bottom": "0 solid transparent",
                                            "border-left": "0 solid transparent",
                                            "border-radius": "8px",
                                            "border-right": "0 solid transparent",
                                            "border-top": "0 solid transparent",
                                            "color": "#FFFFFF",
                                            "direction": "ltr",
                                            "font-family": "inherit",
                                            "font-size": "16px",
                                            "line-height": "200%",
                                            "padding-bottom": "5px",
                                            "padding-left": "20px",
                                            "padding-right": "20px",
                                            "padding-top": "5px",
                                            "width": "auto"
                                        },
                                        "target": "_self"
                                    },
                                    "computedStyle": {
                                        "hideContentOnDesktop": false,
                                        "hideContentOnMobile": false
                                    },
                                    "style": {
                                        "padding-bottom": "10px",
                                        "padding-left": "10px",
                                        "padding-right": "10px",
                                        "padding-top": "10px",
                                        "text-align": "center"
                                    }
                                },
                                "locked": false,
                                "type": "mailup-bee-newsletter-modules-button",
                                "uuid": "14d35b21-a62e-4e66-944f-e8bf3a91ec92"
                            }
                        ],
                        "style": {
                            "background-color": "transparent",
                            "border-bottom": "0 solid transparent",
                            "border-left": "0 solid transparent",
                            "border-right": "0 solid transparent",
                            "border-top": "0 solid transparent",
                            "padding-bottom": "5px",
                            "padding-left": "0px",
                            "padding-right": "0px",
                            "padding-top": "5px"
                        },
                        "uuid": "91865e2d-d812-4e3b-b2d1-28c7e51525b2"
                    }
                ],
                "container": {
                    "style": {
                        "background-color": "#FFFFFF",
                        "background-image": "none",
                        "background-position": "top left",
                        "background-repeat": "no-repeat"
                    }
                },
                "content": {
                    "computedStyle": {
                        "hideContentOnDesktop": false,
                        "hideContentOnMobile": false,
                        "rowColStackOnMobile": true,
                        "rowReverseColStackOnMobile": false,
                        "verticalAlign": "top"
                    },
                    "style": {
                        "background-color": "#FFFFFF",
                        "background-image": "none",
                        "background-position": "top left",
                        "background-repeat": "no-repeat",
                        "color": "#000000",
                        "width": "500px"
                    }
                },
                "empty": false,
                "locked": false,
                "synced": false,
                "type": "",
                "uuid": "904fb7c9-4cec-4e5a-a8f9-2e2534d06085"
            },
            {
                "columns": [
                    {
                        "grid-columns": 12,
                        "modules": [
                            {
                                "descriptor": {
                                    "computedStyle": {
                                        "iconHeight": "32px",
                                        "iconSpacing": {
                                            "padding-bottom": "5px",
                                            "padding-left": "5px",
                                            "padding-right": "5px",
                                            "padding-top": "5px"
                                        },
                                        "itemsSpacing": "0px"
                                    },
                                    "iconsList": {
                                        "icons": [
                                            {
                                                "alt": "Facebook",
                                                "height": "24",
                                                "href": "https://facebook.com/yourcompany",
                                                "id": "3d5a27ae-514b-4082-a241-20de5cd8d426",
                                                "image": "https://example.com/icons/facebook.png",
                                                "target": "_self",
                                                "text": "",
                                                "textPosition": "bottom",
                                                "width": "24"
                                            },
                                            {
                                                "alt": "Instagram",
                                                "height": "24",
                                                "href": "https://instagram.com/yourcompany",
                                                "id": "4bb4c903-e4f6-438b-9c8f-25b127c4b6a5",
                                                "image": "https://example.com/icons/instagram.png",
                                                "target": "_self",
                                                "text": "",
                                                "textPosition": "bottom",
                                                "width": "24"
                                            },
                                            {
                                                "alt": "Twitter",
                                                "height": "24",
                                                "href": "https://twitter.com/yourcompany",
                                                "id": "28e78070-19d6-4011-acef-0e6e82a5e800",
                                                "image": "https://example.com/icons/twitter.png",
                                                "target": "_self",
                                                "text": "",
                                                "textPosition": "bottom",
                                                "width": "24"
                                            }
                                        ]
                                    },
                                    "style": {
                                        "color": "#000000",
                                        "font-family": "inherit",
                                        "font-size": "14px",
                                        "font-weight": "400",
                                        "padding-bottom": "10px",
                                        "padding-left": "0",
                                        "padding-right": "0",
                                        "padding-top": "0",
                                        "text-align": "center"
                                    }
                                },
                                "locked": false,
                                "type": "mailup-bee-newsletter-modules-icons",
                                "uuid": "e874a835-fc33-4ffc-ac80-17f0160ca9b9"
                            },
                            {
                                "descriptor": {
                                    "computedStyle": {
                                        "hideContentOnDesktop": false,
                                        "hideContentOnMobile": false
                                    },
                                    "paragraph": {
                                        "computedStyle": {
                                            "linkColor": "#7DF9FF",
                                            "paragraphSpacing": "16px"
                                        },
                                        "html": "© 2025 Your Company Name. All rights reserved.<br/>123 Innovation Blvd, San Francisco, CA 94107<br/><a href=\"https://yourcompany.com/unsubscribe\" style=\"color:#7DF9FF;\">Unsubscribe</a>",
                                        "style": {
                                            "color": "#36454F",
                                            "direction": "ltr",
                                            "font-family": "inherit",
                                            "font-size": "12px",
                                            "font-weight": "400",
                                            "letter-spacing": "0px",
                                            "line-height": "120%",
                                            "text-align": "center"
                                        }
                                    },
                                    "style": {
                                        "padding-bottom": "10px",
                                        "padding-left": "10px",
                                        "padding-right": "10px",
                                        "padding-top": "10px"
                                    }
                                },
                                "locked": false,
                                "type": "mailup-bee-newsletter-modules-paragraph",
                                "uuid": "c9dd4f26-b534-4ddc-925a-b80384dee256"
                            }
                        ],
                        "style": {
                            "background-color": "transparent",
                            "border-bottom": "0 solid transparent",
                            "border-left": "0 solid transparent",
                            "border-right": "0 solid transparent",
                            "border-top": "0 solid transparent",
                            "padding-bottom": "5px",
                            "padding-left": "0px",
                            "padding-right": "0px",
                            "padding-top": "5px"
                        },
                        "uuid": "3bccd2fd-61d0-4c91-8568-3b177b6d20be"
                    }
                ],
                "container": {
                    "style": {
                        "background-color": "#FFFFFF",
                        "background-image": "none",
                        "background-position": "top left",
                        "background-repeat": "no-repeat"
                    }
                },
                "content": {
                    "computedStyle": {
                        "hideContentOnDesktop": false,
                        "hideContentOnMobile": false,
                        "rowColStackOnMobile": true,
                        "rowReverseColStackOnMobile": false,
                        "verticalAlign": "top"
                    },
                    "style": {
                        "background-color": "#FFFFFF",
                        "background-image": "none",
                        "background-position": "top left",
                        "background-repeat": "no-repeat",
                        "color": "#000000",
                        "width": "500px"
                    }
                },
                "empty": false,
                "locked": false,
                "synced": false,
                "type": "",
                "uuid": "d15e82f3-7e41-40cb-9bb0-f4e0316f839d"
            }
        ],
        "template": {
            "version": "2.0.0"
        },
        "title": ""
    }
}
        )};

        dispatch({
          type: EMAIL_DESIGNER.AI_GENERATE_DESIGN_REQUEST_SUCCESS,
          payload: mockResponse,
        });

        return mockResponse;
      } else {
        const URL = Constants.VNEXT_BASE_URL + "ESP/Design/SendAIGenerateDesignRequest";

        const payload = {
          threadId: threadId,
          requestText: prompt
        };

        await new Promise(resolve => setTimeout(resolve, 2000));
        
        dispatch({
          type: EMAIL_DESIGNER.AI_GENERATE_DESIGN_REQUEST_STAGE_2,
        });

        const apiCallPromise = axios.post(URL, JSON.stringify(payload), {
          headers: {
            'Content-Type': 'application/json',
          },
          params: {
            clientId: clientId
          }
        });

        const [response] = await Promise.all([
          apiCallPromise,
          new Promise(resolve => setTimeout(resolve, 1000))
        ]);

        await new Promise(resolve => setTimeout(resolve, 1000));

        dispatch({
          type: EMAIL_DESIGNER.AI_GENERATE_DESIGN_REQUEST_SUCCESS,
          payload: response.data,
        });

        return response.data;
      }
    } catch (error) {
      console.log("error", error.response);
      dispatch({
        type: EMAIL_DESIGNER.AI_GENERATE_DESIGN_REQUEST_ERROR,
        payload: error.response?.data || error.message,
      });
      throw error;
    }
  };
}

export function submitAIFeedback(clientId, messageId, rating, feedback = '') {
  
  return async function (dispatch) {
    try {
      const URL = `${Constants.VNEXT_BASE_URL}ESP/Design/SubmitAIFeedback?clientId=${clientId}`;
      
      
      const response = await axios.post(URL, {
        messageId,
        rating,
        feedback
      });


      if (response.data.success) {
        dispatch({
          type: EMAIL_DESIGNER.AI_FEEDBACK_SUBMIT_SUCCESS,
          payload: { messageId, rating, feedback }
        });
        return { success: true };
      } else {
        dispatch({
          type: EMAIL_DESIGNER.AI_FEEDBACK_SUBMIT_ERROR,
          payload: response.data.error
        });
        return { success: false, error: response.data.error };
      }
    } catch (error) {
      dispatch({
        type: EMAIL_DESIGNER.AI_FEEDBACK_SUBMIT_ERROR,
        payload: error.response?.data || error.message,
      });
      return { success: false, error: error.message };
    }
  };
}

export function UpdateBeeUnsavedChanges(status = false) {
  return async function (dispatch) {
    try {
      dispatch({
        type: EMAIL_DESIGNER.BEE_UNSAVED_CHANGES,
        payload: status,
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function UpdateIsTriggeredSend(status = false) {
  localStorage.setItem('localStorageTriggerdSendValue', status);
  return async function (dispatch) {
    try {
      dispatch({
        type: EMAIL_DESIGNER.UPDATE_IS_TRIGGERED_SEND_VALUE,
        payload: status,
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function UpdateTrackingParameters(trackingParameters) {
  return async function (dispatch) {
    try {
      dispatch({
        type: EMAIL_DESIGNER.HANDLE_TRACKING_PARAMETERS,
        payload: trackingParameters,
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function UpdateTrackingParametersSelectedItem(trackingParametersSelectedItem) {
  return async function (dispatch) {
    try {
      dispatch({
        type: EMAIL_DESIGNER.HANDLE_TRACKING_PARAMETERS_SELECTED_ITEM,
        payload: trackingParametersSelectedItem,
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}


export function RemoveBEEAuth() {
  return async function (dispatch) {
    try {
      dispatch({
        type: EMAIL_DESIGNER.REMOVE_BEE_AUTH,
        payload: JSON.parse(null),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function onSaveTemplate(param, clientId, isStock, isShared = false) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL + "ESP/Template/Save?clientId=" + clientId;
      if (isStock) {
        URL += `&isStock=${isStock}`;
      }
      if (isShared) {
        URL += `&isShared=${isShared}`;
      }
      const response = await axios({
        method: "post",
        url: URL,
        data: param,
      });

      dispatch({
        type: EMAIL_DESIGNER.ON_SAVE_TEMPLATE,
        payload: response.data,
      });

      return response.data;
    } catch (error) {
      console.log("error", error.response);
    }
  };
}

// const _sleep = (ms) => {
//   return new Promise((resolve) => setTimeout(resolve, ms));
// };
export const saveEmailDesign =
  (clientId, templateId, params, isFromScratch, isNewVersion, isBeaconCall) =>
    async (dispatch) => {
      let response = {};
      if (isBeaconCall) {
        console.log("isBeamCalled: ", isBeaconCall);
        response = await onSaveDesignBeacon(
          clientId,
          templateId ? templateId : 0,
          params,
          isNewVersion
        );
      } else {
        if (isFromScratch) {
          // TODO: Need to propogate changes in redux
          //       so that newer version can be saved on subsequent requests
          response = dispatch(onSaveFromScratch(clientId, params));
        } else {
          response = dispatch(
            onSaveDesign(params, clientId, templateId, false, false, isNewVersion)
          );
        }
      }
      return response;
    };
export const onSaveFromScratchBeacon = (clientId, params) => {
  //TODO: Implement Beacon Call for onSaveFromScratch
  navigator.sendBeacon(
    `http://localhost:3001/?text=BrowserClosed`,
    JSON.stringify(params)
  );
  return { success: true };
};

export const onSaveDesignBeacon = async (
  clientId,
  templateId,
  params,
  isNewVersion = false
) => {
  //TODO: Implement Beacon Call for onSaveDesign: Done
  //TODO: Need to check if it will work with token: Done
  const token = await authService.getAccessToken();
  fetch(
    Constants.VNEXT_BASE_URL +
    "ESP/Design/Save?clientId=" +
    clientId +
    "&templateId=" +
    templateId +
    "&isNewVersion=" +
    isNewVersion,
    {
      keepalive: true,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(params),
    }
  );
  return { success: true };
};

export function onSaveFromScratch(param, clientId) {
  return async function (dispatch) {
    try {
      var response;

      let URL = Constants.VNEXT_BASE_URL + "ESP/Design/SaveFromScratch";

      response = await axios.post(URL, param, {
        params: {
          clientId: clientId,
        },
      });
      //TODO: Get newly saved id back from API and save in current design
      //      So that it can determine that its not a new design on save.
      const payload = HelperFunctions.responseHandlerVNext(response.data);
      dispatch({
        type: EMAIL_DESIGNER.ON_SAVE_DESIGN,
        payload,
      });
      return payload;
    } catch (error) {
      console.log("error", error.response);
    }
  };
}

export function onSaveDesign(
  param,
  clientId,
  templateId,
  isStock = false,
  isShared = false,
  isUpdate = false
) {
  return async function (dispatch) {
    try {
      var response;
      let URL = Constants.VNEXT_BASE_URL + "ESP/Design/Save";
      //TODO: Update API Call to get isNewVersion and handle it properly.
      response = await axios.post(URL, param, {
        params: {
          clientId: clientId,
          templateId: templateId,
          isStock: isStock,
          isShared: isShared,
          isUpdate: isUpdate,
        },
      });
      dispatch({
        type: EMAIL_DESIGNER.ON_SAVE_DESIGN,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
      return response.data;
    } catch (error) {
      console.log("error", error.response);
    }
  };
}

export function GetSeedLists(clientId) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Email/GetSeedListWithCount?clientId=" +
        clientId;

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.SEED_LIST,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function GetDesignUpdateInterval(clientId) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Email/GetEmailDesign?clientId=" +
        clientId;

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.GET_DESIGN_UPDATE_INTERVAL,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function GetTestEmailLists(clientId) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Email/GetTestEmailLists?clientId=" +
        clientId;

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.TEST_EMAIL_LIST,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function sendTestEmail(clientId, param) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + "ESP/Email/SendTestEmail";

      const response = await axios.post(URL, param, {
        params: {
          clientId: clientId,
        },
      });

      const data = response.data;
      dispatch({
        type: EMAIL_DESIGNER.SEND_TEST_EMAIL,
        payload: data,
      });
      return data;
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getAllTemplates(clientId, folderId, parentClientId, isStock, isShared, searchText = "") {
  return async function (dispatch) {
    try {
        if (clientId == 0) { return;}
        let URL = `${Constants.VNEXT_BASE_URL}ESP/Template/GetAll?clientId=${clientId}&isStock=${isStock}&isShared=${isShared}`;
      if (folderId) {
        URL += `&folderId=${folderId}`;
      }
      if (parentClientId) {
        URL += `&parentClientId=${parentClientId}`;
      }
      if (searchText) {
        URL += `&searchText=${encodeURIComponent(searchText)}`;
      }

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.GET_ALL_TEMPLATES,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
      return response.data.content;
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function GetStockFolders(clientId) {
  return async function (dispatch) {
      try {
          if (clientId == 0) { return; }
      let URL = `${Constants.VNEXT_BASE_URL}ESP/Template/GetStockFolders?clientId=${clientId}`;
      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.GET_STOCK_FOLDERS,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
      return response.data.content;
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function GetShareFolders(clientId) {
  return async function (dispatch) {
      try {
          if (clientId == 0) { return; }
      let URL = `${Constants.VNEXT_BASE_URL}ESP/Template/GetShareFolders?ClientId=${clientId}`;
      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.GET_SHARE_FOLDERS,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
      return response.data.content;
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getTemplateByID(clientId, templateId) {
  return async function (dispatch) {
      try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Template/Get?clientId=" +
        clientId +
        "&templateId=" +
        templateId;

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.GET_TEMPLATE_BY_ID,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getTemplateDesignViewMode(clientId) {
  return async function (dispatch) {
      try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Template/GetTemplateDesignViewMode?clientId=" +
        clientId;

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.GET_TEMPLATE_DESIGN_VIEW_MODE,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getAllDesigns(clientId, folderId) {
  return async function (dispatch) {
      try {
      var _folderId = folderId ? folderId : 0;
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Design/GetLibraryContents?clientId=" +
        clientId +
        "&folderId=" +
        _folderId;

      const response = await axios.get(URL);
      dispatch({
        type: EMAIL_DESIGNER.GET_ALL_DESIGNS,
        payload: HelperFunctions.responseHandlerVNext(response.data), //HelperFunctions.responseHandler(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getDesignByID(clientId, designId, isStock, isShared = false) {
  return async function (dispatch) {
    try {
      let URL = `${Constants.VNEXT_BASE_URL}ESP/Design/Get?clientId=${clientId}&designId=${designId}`;
      if (isStock) {
        URL += `&isStock=${isStock}`;
      }
      if (isShared) {
        URL += `&isShared=${isShared}`;
      }
      const response = await axios.get(URL);
      const data = HelperFunctions.responseHandlerVNext(response.data);
      if (data) {
        data.createdDate = Moment(data.createdDate, 'YYYY-MM-DD HH:mm').toDate();
        data.endDate = Moment(data.endDate, 'YYYY-MM-DD HH:mm').toDate();
        data.lastSentDate = Moment(data.lastSentDate, 'YYYY-MM-DD HH:mm').toDate();
        data.modifiedDate = Moment(data.modifiedDate, 'YYYY-MM-DD HH:mm').toDate();
        data.startDate = Moment(data.startDate, 'YYYY-MM-DD HH:mm').toDate();
      }
      dispatch({
        type: EMAIL_DESIGNER.GET_DESIGN_BY_ID,
        payload: data,
      });
      return data;
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}


export function emptyDesignData(payload) {
  return {
    type: EMAIL_DESIGNER.GET_DESIGN_BY_ID,
    payload,
  };
}

export function RemoveEmailDesign(designId, clientId) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + "ESP/Design/Delete";

      const response = await axios.delete(URL, {
        params: {
          clientId: clientId,
          designId: designId,
        },
      });

      dispatch({
        type: EMAIL_DESIGNER.DELETE_DESIGN,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error);
    }
  };
}

export function ConvertHtmlToJson(clientId, designId, html) {
  return async function (dispatch) {
    try {
      const URL = Constants.VNEXT_BASE_URL + "ESP/Design/GetHtmlImport?clientId=" + clientId;
    

      const response = await axios.post(URL, {
        clientId: clientId,
        designId: designId,
        html: html,
      });

      return response.data;
    } catch (error) {
      console.error("error", error);
    }
  };
}

export function SendCommentNotifiction(clientId, designId, notificationType, message, notifySingleUserId,
                                       mentions, commentUrl, emailName, commentAuthorUsername,
                                      clientName,threadContributors = []) {
  return async function (dispatch) {
    try {
      const URL = Constants.VNEXT_BASE_URL + "ESP/Design/SendCommentNotifiction?clientId=" + clientId + "&designId=" + (designId || 0);
      console.log("notifySingleUserId", notifySingleUserId);
      const response = await axios.post(URL, {
        NotificationType: notificationType,
        Message: message,
        NotifySingleUserId: notifySingleUserId,
        Mentions: mentions,
        CommentUrl: commentUrl,
        EmailName: emailName,
        CommentAuthorUsername: commentAuthorUsername,
        ClientName: clientName,
        ThreadContributors: threadContributors
      }, { suppressToast: true });

      return response.data;
    } catch (error) {
      console.error("error", error);
    }
  };
}

export function UpdateCommentHasStatus(clientId, designId, hasComments) {
  return async function (dispatch) {
    try {
      const URL = Constants.VNEXT_BASE_URL + "ESP/Design/UpdateCommentHasStatus?clientId=" + clientId + "&designId=" + designId + "&hasComments=" + hasComments;
      await axios.post(URL, null, { suppressToast: true });
    } catch (error) {
      console.error("[UpdateCommentHasStatus] error", error);
    }
  };
}

export function GetHTMLImportCreditLimit(clientId) {
  return async function (dispatch) {
    try {
      
      let URL = `${Constants.VNEXT_BASE_URL}ESP/Design/GetHTMLImportCreditLimit?clientId=${clientId}`;

      const response = await axios.get(URL);

      return response.data;

    } catch (error) {
      console.error("error", error);
    }
  };
}

export function GetWebHookData(clientId, webHookConfigId) {

  return async function (dispatch) {
    try {

      let URL = `${Constants.VNEXT_BASE_URL}ESP/Design/GetWebhookData?clientId=${clientId}&webhookConfigId=${webHookConfigId}`;

      const response = await axios.get(URL);

      return response.data;

    } catch (error) {
      console.log("error", error);
    }
  };
}

export function ShareTemplate(templateId, clientId, parentClientId) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + "ESP/Template/CreateSharedTemplate";

      const response = await axios.post(URL, null, {
        params: {
          clientId: clientId,
          parentClientId: parentClientId,
          templateId: templateId
        },
      });

      // dispatch({
      //   type: EMAIL_DESIGNER.SHARE,
      //   payload: HelperFunctions.responseHandlerVNext(response.data),
      // });

      return HelperFunctions.responseHandlerVNext(response.data);
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function DisableTemplate(templateId, clientId) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + "ESP/Template/Delete";

      const response = await axios.delete(URL, {
        params: {
          clientId: clientId,
          templateId: templateId,
        },
      });

      dispatch({
        type: EMAIL_DESIGNER.DELETE_TEMPLATE,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error);
    }
  };
}

export function GetFolders(clientId, folderId, searchText = "", status = "") {
  return async function (dispatch) {
    try {
      var _folderId = folderId ? folderId : 0;
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Design/GetLibraryContents?clientId=" +
        clientId +
        "&folderId=" +
        _folderId +
        "&searchText=" +
        encodeURIComponent(searchText) +
        "&status=" +
        status;

      const response = await axios.get(URL);

      var helper = HelperFunctions.responseHandlerVNext(response.data); //HelperFunctions.responseHandler(response.data);

      //if (_folderId === 0) {
      //  helper.designs = helper.designs.filter((row) => row.folderId == null);
      //};

      dispatch({
        type: EMAIL_DESIGNER.GET_ALL_FOLDERS,
        payload: helper,
      });
      return helper;
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function GetAllFolders(
  clientId,
  folderId,
  allFolders,
  isTemplate = false
) {
  
  return async function (dispatch) {
    try {
      var _folderId = folderId ? folderId : 0;
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Design/GetFolders?clientId=" +
        clientId +
        "&folderId=" +
        _folderId +
        "&allFolders=" +
        allFolders +
        "&isTemplate=" +
        isTemplate;

      const response = await axios.get(URL);
      const data = HelperFunctions.responseHandlerVNext(response.data);
      dispatch({
        type: EMAIL_DESIGNER.GET_ALL_FOLDERS_TREEVIEW,
        payload: data,
      });
      return data;
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getAllTrackingparams(clientId) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Design/GetTrackingParameters?clientId=" +
        clientId;

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.GET_ALL_TRACKING_PARAMS,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getAppendTrackingParameters(clientId) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Design/GetAppendTrackingParameter?clientId=" +
        clientId;

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.GET_APPEND_TRACKING_PARAMS,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function Pause(clientId, designId) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + "ESP/Design/PauseDesign";

      const response = await axios.post(URL, null, {
        params: {
          clientId: clientId,
          designId: designId
        },
      });

      dispatch({
        type: EMAIL_DESIGNER.PAUSE,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function Resume(clientId, designId) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + "ESP/Email/ResumeEmail";

      const response = await axios.post(URL, null, {
        params: {
          clientId: clientId,
          designId: designId
        },
      });

      dispatch({
        type: EMAIL_DESIGNER.RESUME,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
      
      return response.data;
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}


export function SaveAbandonCartSchedule(clientId, params) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + "ESP/Email/SaveAbandonCartSchedule?clientId="+clientId;

      const response = await axios.post(URL, params);
   
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}


export function EnableAbandonCartEmail(params) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + "ESP/Email/EnableAbandonCartEmail";

      const response = await axios.post(URL, null,{
        params :{
          ReplyEmail : params.ReplyEmail,
          FromAddress : params.FromAddress,
          clientId : params.clientId,
          DesignId : params.DesignId
        }
      });
   
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function Unpublish(clientId, designId, completed = false) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + "ESP/Design/Unpublish";

      const response = await axios.post(URL, null, {
        params: {
          clientId: clientId,
          designId: designId,
          completed: completed,
        },
      });

      dispatch({
        type: EMAIL_DESIGNER.UNPUBLISH,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function Duplicate(
  clientId,
  designId,
  newDesignName,
  folderId,
  preserveSourceData = false
) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + "ESP/Design/Duplicate";

      const response = await axios.post(URL, null, {
        params: {
          clientId: clientId,
          designId: designId,
          newDesignName: newDesignName,
          folderId: folderId,
          preserveSourceData: preserveSourceData,
        },
      });

      dispatch({
        type: EMAIL_DESIGNER.DUPLICATE,
        payload: response.data,
      });

      return response.data;
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function Move(clientId, designId, targetFolderId, isTemplate = false) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + "ESP/Design/Move";

      const response = await axios.post(URL, null, {
        params: {
          clientId: clientId,
          designId: designId,
          targetFolderId: targetFolderId,
          isTemplate: isTemplate
        },
      });

      dispatch({
        type: EMAIL_DESIGNER.MOVE,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function archive(clientId, folderId, parentId) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + "ESP/Design/Archive";

      const response = await axios.post(URL, null, {
        params: {
          clientId: clientId,
          folderId: folderId,
          parentId: parentId,
        },
      });

      dispatch({
        type: EMAIL_DESIGNER.ARCHIVE,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function rename(clientId, folderId, name, parentId, type) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + "ESP/Design/Rename";

      const response = await axios.post(URL, null, {
        params: {
          clientId: clientId,
          folderId: folderId,
          name: name,
          parentId: parentId,
          type: type
        },
      });

      dispatch({
        type: EMAIL_DESIGNER.RENAME,
        payload: response.data,
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function addFolder(clientId, param, folderId) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + "ESP/Design/AddFolder";

      const response = await axios.post(URL, param, {
        params: {
          clientId: clientId,
        },
      });

      dispatch({
        type: EMAIL_DESIGNER.ADD_FOLDER,
        payload: response.data,
      });
      return response.data;
    } catch (error) {
      console.log("error", error.response);
    }
  };
}

export function getSuppressionList(clientId) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.CONT_BASE_URL +
        "ESP/Email/GetSuppressionLists?clientId=" +
        clientId;

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.SUPPRESION_LIST,
        payload: HelperFunctions.responseHandler(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getAudienceCampaignList(clientId) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Email/GetCampaignsAndAudiences?clientId=" +
        clientId;

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.AUDIENCE_CAMPAIGN_LIST,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getAudienceCampaignCount(clientId, audienceType, audienceId) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Email/GetCampaignsOrAudienceCount?clientId=" +
        clientId + "&audienceType=" + audienceType + "&audienceId=" + audienceId;

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.AUDIENCE_CAMPAIGN_COUNT,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}


export function getSuppressionCampaignCount(clientId, audienceType, audienceId) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Email/GetCampaignsOrAudienceCount?clientId=" +
        clientId + "&audienceType=" + audienceType + "&audienceId=" + audienceId;

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.SUPPRESSION_CAMPAIGN_COUNT,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function sendEmail(clientId, data) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + "ESP/Email/SendEmail";
      const response = await axios.post(URL, data, {
        params: {
          clientId: clientId,
        },
      });
      // const response = await axios.post(
      //   Constants.CONT_BASE_URL + "ESP/Email/SendEmail",
      //   {
      //     emailViewModel: data,
      //   },
      //   {
      //     params: {
      //       clientId: clientId,
      //     },
      //   }
      // );

      dispatch({
        type: EMAIL_DESIGNER.SEND_EMAIL,
        payload: response.data,
      });
      return response.data;
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getFromEmailAddresses(clientId) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Email/GetFromEmailList?clientId=" +
        clientId;

      const response = await axios.get(URL);
      const data = HelperFunctions.responseHandlerVNext(response.data);

      dispatch({
        type: EMAIL_DESIGNER.GET_FROM_ADDRESSES,
        payload: data,
      });
      // Return in middleware-transformed format so callers that capture the
      // return value get {label, value, IsDefault} — matching the Redux store.
      return (data || []).map((item) => ({
        label: item.fromEmailAddress,
        value: item.fromEmailAddress,
        IsDefault: item.isDefault,
      }));
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

// export function GetDefaultValues(clientId) {
//   return async function (dispatch) {
//     try {
//       let URL =
//         Constants.VNEXT_BASE_URL +
//         "shared/GetDefaultValues?clientId=" +
//         clientId;

//       const response = await axios.get(URL);

//       dispatch({
//         type: EMAIL_DESIGNER.GET_DEFUALT_VALUES,
//         payload: HelperFunctions.responseHandlerVNext(response.data),
//       });
//     } catch (error) {
//       console.log("error", error.response);
//       console.log(typeof error);
//     }
//   };
// }

export function getReplyToEmailAddresses(clientId) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Email/GetReplyToEmailList?clientId=" +
        clientId;

      const response = await axios.get(URL);
      const data = HelperFunctions.responseHandlerVNext(response.data);

      dispatch({
        type: EMAIL_DESIGNER.GET_REPLY_EMAIL_ADDRESSES,
        payload: data,
      });
      // Return in middleware-transformed format so callers that capture the
      // return value get {label, value, IsDefault} — matching the Redux store.
      return (data || []).map((item) => ({
        label: item.replyToEmailAddress,
        value: item.replyToEmailAddress,
        IsDefault: item.isDefault,
      }));
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getImageLibraryContents(clientId, path = "") {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Image/GetDirectoryContents?clientId=" +
        clientId +
        "&path=" +
        encodeURIComponent(path);
      let data = {};
      let folders = [];
      let images = [];
      const response = await axios.get(URL);
      var res = HelperFunctions.responseHandlerVNext(response.data);
      for (let index in res.directoryContents) {
        if (res.directoryContents[index].filePath) {
          res.directoryContents[index].fileType = res.directoryContents[
            index
          ].fileType
            .substr(1)
            .toUpperCase();
          res.directoryContents[index].fileAbsolutePath =
            Constants.VNEXT_BASE_URL +
            res.directoryContents[index].fileAbsolutePath +
            "?a=" +
            Math.random();
          images.push(res.directoryContents[index]);
        } else {
          folders.push(res.directoryContents[index]);
        }
      }
      data["Count"] = res.count;
      data["CurrentDirectoryPath"] = res.currentDirectoryPath;
      data["DefaultDirectoryPath"] = res.defaultDirectoryPath;
      data["LastModifiedDate"] = res.lastModifiedDate;
      data["Size"] = res.size;
      data["TopLevelDirectoryPath"] = res.topLevelDirectoryPath;
      data["folders"] = folders;
      data["images"] = images;

      dispatch({
        type: EMAIL_DESIGNER.GET_IMAGE_LIBRARY_CONTENTS,
        payload: data,
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function updateSelectedFolderName(payload) {
  return {
    type: EMAIL_DESIGNER.SELECTED_FOLDER_NAME,
    payload,
  };
}

export function AddDirectoryInLibrary(clientId, path, name) {
  return async function (dispatch) {
    try {
      var object = new Object();
      object.path = path;
      object.name = name;

      let URL = Constants.VNEXT_BASE_URL + "ESP/Image/AddDirectory";

      const response = await axios.post(URL, object, {
        params: {
          clientId: clientId,
        },
      });

      dispatch({
        type: EMAIL_DESIGNER.ADD_DIRECTORY,
        payload: response.data,
      });
      return response.data;
    } catch (error) {
      console.log("error", error);
    }
  };
}

export function UploadImage(clientId, path, files, overwrite) {
  return async function (dispatch) {
    try {
      const formData = new FormData();
      for (var i = 0; i < files.length; i++) {
        formData.append("file" + i, files[i]);
      }

      //formData.append('model', {Path: path, Overwrite: overwrite});
      //formData.append('overwrite', overwrite);
      // const config = {
      //   headers: {
      //     "content-type": "multipart/form-data",
      //   },
      // };
      let URL = Constants.VNEXT_BASE_URL + "ESP/Image/Upload";
      // var payload = {
      //   Path: path,
      //   Overwrite: overwrite,
      // };
      const response = await axios.post(URL, formData, {
        params: {
          clientId: clientId,
          path: path,
          overwrite: overwrite,
        },
      });

      dispatch({
        type: EMAIL_DESIGNER.UPLOAD_IMAGE,
        payload: response.data,
      });
      return response.data;
    } catch (error) {
      console.log("error", error);
    }
  };
}

export function ValidateUpload(clientId, path, fileNames) {
  return async function (dispatch) {
    try {
      const formData = new FormData();
      formData.append("path", path);
      formData.append("fileNames", fileNames);
      let URL = Constants.VNEXT_BASE_URL + "ESP/Image/ValidateUpload";

      const response = await axios.post(URL, formData, {
        params: {
          clientId: clientId,
        },
      });

      dispatch({
        type: EMAIL_DESIGNER.VALIDATE_UPLOAD,
        payload: response.data,
      });
      return response.data;
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function DeleteLibraryContent(
  clientId,
  param,
  isChildContentDelete = false
) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + "ESP/Image/Delete";
      var object = new Object();
      object.paths = param;
      object.isChildContentDelete = isChildContentDelete;

      const response = await axios.post(URL, object, {
        params: {
          clientId: clientId,
        },
      });

      dispatch({
        type: EMAIL_DESIGNER.DELETE_CONTENT,
        payload: response.data,
      });
      return response.data;
    } catch (error) {
      console.log("error", error);
    }
  };
}

export function ReplaceImage(clientId, path, file, oldFileName) {
  return async function (dispatch) {
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("path", path);
      formData.append("oldFileName", oldFileName);

      let URL = Constants.VNEXT_BASE_URL + "ESP/Image/Replace";

      const response = await axios.post(URL, formData, {
        params: {
          clientId: clientId,
        },
      });

      dispatch({
        type: EMAIL_DESIGNER.REPLACE_IMAGE,
        payload: response.data,
      });
    } catch (error) {
      console.log("error", error);
    }
  };
}

export function getReportOverViewEmailSummary(
  clientId,
  templateId,
  startDate,
  endDate
) {
  return async function (dispatch) {
    try {
      templateId = templateId === null ? "" : templateId;
      startDate = startDate === null ? "" : startDate;
      endDate = endDate === null ? "" : endDate;
      let URL = `${Constants.VNEXT_BASE_URL}ESP/Overview/GetEmailSummary?clientId=${clientId}&templateId=${templateId}&startDate=${startDate}&endDate=${endDate}`;

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.REPORT_OVERVIEW_EMAIL_SUMMARY,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getReportOverViewOpenAndClickRate(
  clientId,
  templateId,
  startDate,
  endDate
) {
  return async function (dispatch) {
    try {
      templateId = templateId === null ? "" : templateId;
      startDate = startDate === null ? "" : startDate;
      endDate = endDate === null ? "" : endDate;
      let URL = `${Constants.VNEXT_BASE_URL}ESP/Overview/GetOpenAndClickRate?clientId=${clientId}&templateId=${templateId}&startDate=${startDate}&endDate=${endDate}`;
      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.REPORT_OVERVIEW_OPEN_AND_CLICK_RATE,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getTopBottomPerformingSummary(
  clientId,
  performanceType,
  startDate,
  endDate
) {
  return async function (dispatch) {
    try {
      startDate = startDate === null ? "" : startDate;
      endDate = endDate === null ? "" : endDate;
      let URL = `${Constants.VNEXT_BASE_URL}ESP/Overview/GetTopBottomPerformingSummary?clientId=${clientId}&performanceType=${performanceType}&startDate=${startDate}&endDate=${endDate}`;

      const response = await axios.get(URL);

      const data = HelperFunctions.responseHandlerVNext(response.data);
      dispatch({
        type: EMAIL_DESIGNER.TOP_BOTTOM_PERFORMING_SUMMARY,
        payload: data,
      });
      return data;
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getDesignCountByClientId(clientId, startDate, endDate) {
  return async function (dispatch) {
    try {
      startDate = startDate === null ? "" : startDate;
      endDate = endDate === null ? "" : endDate;
      let URL = `${Constants.VNEXT_BASE_URL}ESP/Overview/GetDesignsCountByClientId?clientId=${clientId}&startDate=${startDate}&endDate=${endDate}`;
      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.DESIGN_COUNT_BY_CLIENT,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getDesignsByClientId(clientId, startDate, endDate) {
  return async function (dispatch) {
    try {
      startDate = startDate === null ? "" : startDate;
      endDate = endDate === null ? "" : endDate;
      let URL = `${Constants.VNEXT_BASE_URL}ESP/Overview/GetDesignDropdownByClientId?clientId=${clientId}&startDate=${startDate}&endDate=${endDate}`;

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.DESIGN_DROPDOWN_BY_CLIENT,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function GetEmailDetail(clientId, templateId) {
  return async function (dispatch) {
    try {
      templateId = templateId === null ? "" : templateId;
      let URL = `${Constants.VNEXT_BASE_URL}ESP/Overview/GetEmailDetail?clientId=${clientId}&templateId=${templateId}`;

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.DESIGN_EMAIL_DETAIL,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getSubscriberTopLinks(
  clientId,
  templateId,
  startDate,
  endDate
) {
  return async function (dispatch) {
    try {
      templateId = templateId === null ? "" : templateId;
      startDate = startDate === null ? "" : startDate;
      endDate = endDate === null ? "" : endDate;
      let URL = `${Constants.VNEXT_BASE_URL}ESP/Overview/GetSubscriberTopLinks?clientId=${clientId}&templateId=${templateId}&startDate=${startDate}&endDate=${endDate}`;

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.REPORT_SUBSCRIBER_TOP_LINKS,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getSubscriberMostOpens(
  clientId,
  templateId,
  startDate,
  endDate
) {
  return async function (dispatch) {
    try {
      templateId = templateId === null ? "" : templateId;
      startDate = startDate === null ? "" : startDate;
      endDate = endDate === null ? "" : endDate;
      const URL = `${Constants.VNEXT_BASE_URL}ESP/Overview/GetSubscriberMostOpens?clientId=${clientId}&templateId=${templateId}&startDate=${startDate}&endDate=${endDate}`;

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.REPORT_SUBSCRIBER_MOST_OPENS,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getSubscribersDetails(clientId, templateId) {
  return async function (dispatch) {
    try {
      templateId = templateId === null ? "" : templateId;
      let URL = `${Constants.VNEXT_BASE_URL}ESP/Overview/GetSubscribersDetails?clientId=${clientId}&templateId=${templateId}`;

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.SUBSCRIBERS_DETAILS,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

//export function saveTouchPointsForMapping(
//  clientId,
//  designId,
//  playTouchPointId
//) {
//  return async function (dispatch) {
//    try {
//      let URL =
//        Constants.VNEXT_BASE_URL + "ESP/Design/SaveTouchPointsForMapping";

//      const response = await axios.post(URL, null, {
//        params: {
//          clientId: clientId,
//          designId: designId,
//          playTouchPointId: playTouchPointId,
//        },
//      });

//      dispatch({
//        type: EMAIL_DESIGNER.SAVE_TOUCHPOINT_MAPPING,
//        payload: HelperFunctions.responseHandlerVNext(response.data),
//      });
//    } catch (error) {
//      console.log("error", error.response);
//      console.log(typeof error);
//    }
//  };
//}

export function GetImageLibraryFolders(clientId, path = "") {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Image/GetFolders?clientId=" +
        clientId +
        "&path=" +
        encodeURIComponent(path);

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.GET_ALL_IMAGE_LIBRARY_FOLDERS_TREEVIEW,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function GetExternalImages(
  clientId,
  providerId,
  searchText,
  categories,
  pageNumber = 1,
  pageSize = 10
) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Image/GetExternalImages?clientId=" +
        clientId +
        "&providerId=" +
        providerId +
        "&searchText=" +
        encodeURIComponent(searchText) +
        "&categories=" +
        categories +
        "&pageNumber=" +
        pageNumber +
        "&pageSize=" +
        pageSize;

      var processedResult = await axios.get(URL).then((result) => {
        var responseData = HelperFunctions.responseHandlerVNext(result.data);
        if (responseData && responseData.directoryContents) {
          const externalAxios = axios.create();
          responseData.directoryContents.map((item) => {
            externalAxios
              .head(item.filePath)
              .then(function (imageResponse) {
                item.size = imageResponse.headers["content-length"];
              })
              .catch(function (error) {
                console.log("error: ", error);
                item.size = 0;
              });
          });
        }
        return responseData;
      });
      emptyExternalImages(null);
      dispatch({
        type: EMAIL_DESIGNER.GET_EXTERNAL_IMAGES,
        payload: processedResult,
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

// export async function getContentLength(url) {
//   if(url) {
//     try {
//       console.log("URL: ",url);
//       const response = await axios.head(url);
//       console.log("response:", response);
//       console.log('in getContentLength ', response, response.headers, response.headers["Content-Length"]);

//       return response.headers["Content-Length"];

//     }
//     catch (error) {
//       console.log("error: ", error);
//         console.log("error", error.response);
//     }
//   }
//       return 0;
// }

export function emptyExternalImages(payload) {
  return {
    type: EMAIL_DESIGNER.GET_EXTERNAL_IMAGES,
    payload,
  };
}

export function emptyImageLibraryContents(payload) {
  return {
    type: EMAIL_DESIGNER.EMAIL_DESIGNER.GET_IMAGE_LIBRARY_CONTENTS,
    payload,
  };
}

export function emptyExternalCategories(payload) {
  return {
    type: EMAIL_DESIGNER.GET_EXTERNAL_CATEGORIES,
    payload,
  };
}

export function GetExternalCategories(clientId, providerId, searchText) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Image/GetExternalCategories?clientId=" +
        clientId +
        "&providerId=" +
        providerId +
        "&searchText=" +
        encodeURIComponent(searchText);

      const response = await axios.get(URL);
      const responseData = HelperFunctions.responseHandlerVNext(response.data);

      dispatch({
        type: EMAIL_DESIGNER.GET_EXTERNAL_CATEGORIES,
        payload: responseData,
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function saveSchedule(clientId, scheduleTriggerId, data) {
  return async function (dispatch) {
    try {
      const response = await axios.post(
        Constants.VNEXT_BASE_URL + "ESP/Email/SaveSchedule",
        {
          sendNow: data.SendNow,
          isScheduleSend: data.IsScheduleSend,
          scheduleDateTime: data.ScheduleDateTime,
          scheduleTimeZone: data.ScheduleTimeZone,
          scheduleRecurring: data.ScheduleRecurring,
          scheduleRecurrence: data.ScheduleRecurrence,
          scheduleDayOfMonth: data.ScheduleDayOfMonth,
          scheduleDaysOfWeek: data.ScheduleDaysOfWeek,
          scheduleEndDate: data.ScheduleEndDate,
          runAfterCDPSnapshot: data.RunAfterCDPSnapshot,
        },
        {
          params: {
            clientId: clientId,
            scheduleTriggerId: scheduleTriggerId,
          },
        }
      );

      dispatch({
        type: EMAIL_DESIGNER.SAVE_SCHEDULE,
        payload: response.data,
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getScheduleTriggerById(clientId, scheduleTriggerId) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Email/GetScheduleTriggerById?clientId=" +
        clientId +
        "&scheduleTriggerId=" +
        scheduleTriggerId;

      const response = await axios.get(URL);

      const data = HelperFunctions.responseHandlerVNext(response.data);
      if (data) {
        const offset = Moment().utcOffset();
        if (data.startDate) {
          console.log(data.startDate);
          data.startDate = new Moment(data.startDate).utcOffset(offset).format();
          console.log(data.startDate);
        }
        if (data.endDate) {
          console.log(data.endDate);
          data.endDate = new Moment(data.endDate).utcOffset(offset).format();
          console.log(data.endDate);
        }
      }

      dispatch({
        type: EMAIL_DESIGNER.SCHEDULE_TRIGGERS,
        payload: data,
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function addFolderBreadcrumb(payload) {
  return {
    type: EMAIL_DESIGNER.DESIGN_BREADCRUMBS_ADD,
    payload,
  };
}

export function removeFolderBreadcrumb(payload) {
  return {
    type: EMAIL_DESIGNER.DESIGN_BREADCRUMBS_REMOVE,
    payload,
  };
}
export function addTemplateFolderBreadcrumb(payload) {
  return {
    type: EMAIL_DESIGNER.TEMPLATE_BREADCRUMBS_ADD,
    payload,
  };
}

export function removeTemplateFolderBreadcrumb(payload) {
  return {
    type: EMAIL_DESIGNER.TEMPLATE_BREADCRUMBS_REMOVE,
    payload,
  };
}
export function removeAllTemplateFolderBreadcrumbsAfterIndex(payload) {
  return {
    type: EMAIL_DESIGNER.TEMPLATE_BREADCRUMBS_REMOVE_ALL,
    payload,
  };
}

export function getMergeTags(clientId) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL + "ESP/Email/GetMergeTags?clientId=" + clientId;

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.BEE_MERGE_TAGS,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function ToggleBeeReloadState(state) {
  return async function (dispatch) {
    try {
  
      dispatch({
        type: EMAIL_DESIGNER.RELOAD_BEE_EDITOR,
        payload: state
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function moveImages(clientId, paths, currentDirectory, selectedFolder) {
  return async function (dispatch) {
    try {
      var object = new Object();
      object.paths = paths;
      object.currentDirectoryPath = currentDirectory;
      object.selectedFolderPath = selectedFolder;
      let URL = Constants.VNEXT_BASE_URL + "ESP/Image/Move";

      const response = await axios.post(URL, object, {
        params: {
          clientId: clientId,
        },
      });

      dispatch({
        type: EMAIL_DESIGNER.MOVE_IMAGES,
        payload: response.data,
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function addImageLibraryBreadcrumb(payload) {
  return {
    type: EMAIL_DESIGNER.IMAGE_BREADCRUMBS_ADD,
    payload,
  };
}

export function removeImageLibraryBreadcrumb(payload) {
  return {
    type: EMAIL_DESIGNER.IMAGE_BREADCRUMBS_REMOVE,
    payload,
  };
}
export function getCustomFonts(clientId) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Bee/GetCustomFonts?clientId=" +
        clientId;

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.CLIENT_FONTS,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getCustomColors(clientId) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Bee/GetCustomColors?clientId=" +
        clientId;

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.CLIENT_COLORS,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getContentDefaults(clientId) {
  return async function (dispatch) {
    try {
      const URL = Constants.VNEXT_BASE_URL + "ESP/Bee/GetContentDefaults?clientId=" + clientId;
      const response = await axios.get(URL);
      dispatch({
        type: EMAIL_DESIGNER.CLIENT_CONTENT_DEFAULTS,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
    }
  };
}

export function saveContentDefaults(clientId, payload) {
  return async function () {
    try {
      const URL = Constants.VNEXT_BASE_URL + "ESP/Bee/SaveContentDefaults?clientId=" + clientId;
      const response = await axios.post(URL, payload);
      return response.data;
    } catch (error) {
      console.log("error", error.response);
      throw error;
    }
  };
}

export function getAiTrainingHub(clientId) {
  return async function (dispatch) {
    try {
      const URL = Constants.VNEXT_BASE_URL + "ESP/Bee/GetAiTrainingHub?clientId=" + clientId;
      const response = await axios.get(URL);
      dispatch({
        type: EMAIL_DESIGNER.CLIENT_AI_TRAINING_HUB,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
    }
  };
}

export function saveAiTrainingHub(clientId, payload) {
  return async function () {
    try {
      const URL = Constants.VNEXT_BASE_URL + "ESP/Bee/SaveAiTrainingHub?clientId=" + clientId;
      const response = await axios.post(URL, payload);
      return response.data;
    } catch (error) {
      console.log("error", error.response);
    }
  };
}

export function UpdateCustomColors(clientId, payload) {
  return async function (dispatch) {
    try {
      const URL = Constants.VNEXT_BASE_URL + "ESP/Bee/UpdateCustomColors?clientId=" + clientId;

      const response = await axios.post(URL, payload);
      // Optional: handle success
      return response.data;

    } catch (error) {
      console.log("error", error.response);
    }
  };
}


export function getScheduleTriggerByEmailTemplateId(clientId, designId) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Design/GetScheduleTriggerByEmailTemplateId?clientId=" +
        clientId +
        "&designId=" +
        designId;

      const response = await axios.get(URL);

      const payload = HelperFunctions.responseHandlerVNext(response.data);
      dispatch({
        type: EMAIL_DESIGNER.DESIGN_SCHEDULE_TRIGGER,
        payload,
      });
      return payload;
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function DisableScheduleTrigger(clientId, designId) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + "ESP/Design/DisableScheduleTrigger";

      const response = await axios.post(URL, null, {
        params: {
          clientId: clientId,
          designId: designId,
        },
      });

      dispatch({
        type: EMAIL_DESIGNER.DISABLED_SCHEDULED,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function DisableEdit(clientId, designId) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + "ESP/Design/DisableEdit";

      const response = await axios.post(URL, null, {
        params: {
          clientId: clientId,
          designId: designId,
        },
      });

      dispatch({
        type: EMAIL_DESIGNER.DISABLED_EDIT_SCHEDULED,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getSendsPageData(clientId, templateStatus, startDate, endDate) {
  return async function (dispatch) {
    try {
      startDate = startDate == null ? "" : startDate;
      endDate = endDate == null ? "" : endDate;
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Email/GetSends?clientId=" +
        clientId +
        "&templateStatus&startDate=" +
        startDate +
        "&endDate=" +
        endDate;

      if (templateStatus)
        URL =
          Constants.VNEXT_BASE_URL +
          "ESP/Email/GetSends?clientId=" +
          clientId +
          "&templateStatus=" +
          templateStatus +
          "&startDate=" +
          startDate +
          "&endDate=" +
          endDate;

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.REPORT_SENDS_PAGE,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getDynamicListData(clientId, fieldName, searchPattern) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Bee/GetDynamicListData?clientId=" +
        clientId +
        "&fieldName=" +
        fieldName +
        "&searchPattern=";
      if (searchPattern != null && searchPattern !== "") {
        URL = URL + searchPattern;
      }
      const response = await axios.get(URL);
      const data = HelperFunctions.responseHandlerVNext(response.data);
      dispatch({
        type: EMAIL_DESIGNER.DYNAMICFIELDS,
        payload: data,
      });
      return data;
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getDynamicContentFields(clientId) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Bee/GetDynamicEmailContentFields?clientId=" +
        clientId;

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.DYNAMIC_CONTENT_FIELDS,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function ValidatePageScrapeUrl(url) {
  return async function (dispatch) {
    try {
      let URL = `${Constants.VNEXT_BASE_URL
        }ESP/Bee/ValidatePageScrapeUrl?url=${encodeURIComponent(
          url
        )}`;
      const response = await axios.get(URL);
      dispatch({
        type: EMAIL_DESIGNER.EXTERNAL_URL_VALIDATION,
        payload: response.data,
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function AddRow(categoryId, name, rowJSON, clientId, templateId = null, versionId = null) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL + "ESP/Design/AddRow?clientId=" + clientId;
      let params = {
        SaveRowName: name,
        CategoryId: categoryId,
        SaveRowJSON: rowJSON,
        TemplateId: templateId,
        VersionId: versionId
      };
      const response = await axios({
        method: "post",
        url: URL,
        data: params,
      });
      const handledResponse = HelperFunctions.responseHandlerVNext(response.data);
      dispatch({
        type: EMAIL_DESIGNER.ON_SAVE_ROW,
        payload: handledResponse,
      });
      // Return the response so caller can get savedRowId
      return handledResponse;
    } catch (error) {
      console.log("error", error.response);
      return null;
    }
  };
}

export function GetSavedRowsCategories(clientId) {
  return async function (dispatch) {
    try {
      let URL = `${Constants.VNEXT_BASE_URL}ESP/Design/GetSavedRowsCategories?clientId=${clientId}`;
      const response = await axios.get(URL);
      dispatch({
        type: EMAIL_DESIGNER.SAVED_ROWS_CATEGORIES,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function GetSavedRowsByCategoryId(clientId, categoryId, designId) {
  return async function (dispatch) {
    try {
      let URL = `${Constants.VNEXT_BASE_URL}ESP/Design/GetSavedRowsByCategoryId?clientId=${clientId}&categoryId=${categoryId}&designId=${designId}`;
      const response = await axios.get(URL);
      const data = HelperFunctions.responseHandlerVNext(response.data);
      dispatch({
        type: EMAIL_DESIGNER.SAVED_ROWS,
        payload: data,
      });
      return data;
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function AddRowValidations(clientId, categoryId, rowName) {
  return async function (dispatch) {
    try {
      let URL = `${Constants.VNEXT_BASE_URL
        }ESP/Design/AddRowValidations?clientId=${clientId}&categoryId=${categoryId}&rowName=${rowName}`;
      const response = await axios.get(URL);
      dispatch({
        type: EMAIL_DESIGNER.SAVE_ROW_VALIDATION,
        payload: response.data,
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function GetSavedRowById(clientId, savedRowId) {
  return async function (dispatch) {
    try {
      let URL = `${Constants.VNEXT_BASE_URL}ESP/Design/GetSavedRowById?clientId=${clientId}&savedRowId=${savedRowId}`;
      const response = await axios.get(URL);
      return HelperFunctions.responseHandlerVNext(response.data);
    } catch (error) {
      console.log("error", error.response);
      throw error;
    }
  };
}

export function UpdateRow(clientId, savedRowId, rowName, rowJSON, isSynced, templateId, versionId) {
  return async function (dispatch) {
    try {
      let URL = `${Constants.VNEXT_BASE_URL}ESP/Design/UpdateRow?clientId=${clientId}`;
      let params = {
        SaveRowId: savedRowId,
        SaveRowName: rowName,
        SaveRowJSON: rowJSON,
        IsSynced: isSynced,
        TemplateId: templateId,
        VersionId: versionId,
      };
      const response = await axios({
        method: "post",
        url: URL,
        data: params,
      });
      return HelperFunctions.responseHandlerVNext(response.data);
    } catch (error) {
      console.log("error", error.response);
      throw error;
    }
  };
}

export function DeleteSavedRow(clientId, savedRowId, isPreferenceCenterSavedRow = false) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + "ESP/Design/DeleteSavedRow";

      const response = await axios.delete(URL, {
        params: {
          clientId: clientId,
          savedRowId: savedRowId,
          isPreferenceCenterSavedRow: isPreferenceCenterSavedRow
        },
      });

      dispatch({
        type: EMAIL_DESIGNER.DELETE_SAVED_ROW,
        payload: response.data,
      });
      return response.data;
    } catch (error) {
      console.log("error", error);
      return error;
    }
  };
}

export function postEmailSendToDetails(sendToVM) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + `ESP/Email/SaveUpdateSendTo?clientId=${sendToVM.ClientId}`;
      const response = await axios.post(URL, sendToVM);
      var responseModel = HelperFunctions.responseHandlerVNext(response.data);
      dispatch({
        type: EMAIL_DESIGNER.SEND_EMAIL_SEND_TO,
        payload: responseModel
      });
      return responseModel;
    } catch (error) {
      console.log("error", error);
      return error;
    }
  };
}

export function postEmailFromDetails(fromVM) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + `ESP/Email/SaveUpdateFrom?clientId=${fromVM.ClientId}`;
      const response = await axios.post(URL, fromVM);
      var responseModel = HelperFunctions.responseHandlerVNext(response.data);
      dispatch({
        type: EMAIL_DESIGNER.SEND_EMAIL_FROM,
        payload: responseModel
      });
      return responseModel;
    } catch (error) {
      console.log("error", error);
      return error;
    }
  };
}

export function postPropertiesDetails(propertiesVM) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + `ESP/Email/SaveUpdateProperties?clientId=${propertiesVM.ClientId}`;
      const response = await axios.post(URL, propertiesVM);
      var responseModel = HelperFunctions.responseHandlerVNext(response.data);
      dispatch({
        type: EMAIL_DESIGNER.SEND_EMAIL_PROPERTIES,
        payload: responseModel
      });
      return responseModel;
    } catch (error) {
      console.log("error", error);
      return error;
    }
  };
}

export function postScheduleDetails(scheduleVM) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + `ESP/Email/SaveUpdateSchedule?clientId=${scheduleVM.ClientId}`;
      const response = await axios.post(URL, scheduleVM);
      var responseModel = HelperFunctions.responseHandlerVNext(response.data);
      dispatch({
        type: EMAIL_DESIGNER.DESIGN_SCHEDULE_TRIGGER,
        payload: responseModel
      });
      return response.data;
    } catch (error) {
      console.log("error", error);
      return error;
    }
  };
}

export function postWebhookTriggerDetails(scheduleVM) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + `ESP/Email/SaveUpdateWebhookTrigger?clientId=${scheduleVM.ClientId}`;
      const response = await axios.post(URL, scheduleVM);
      var responseModel = HelperFunctions.responseHandlerVNext(response.data);
      dispatch({
        type: EMAIL_DESIGNER.DESIGN_WEBHOOK_TRIGGER,
        payload: responseModel
      });
      return response.data;
    } catch (error) {
      console.log("error", error);
      return error;
    }
  };
}

export const getEspUserCredit = (clientId) => async (dispatch) => {
  try {
    const URL = `${(import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API)}ESP/Email/GetESPUserCredit?clientId=${clientId}`;
    const response = await axios.get(URL);
    if (response.data.operationSuccessful) {
      dispatch({
        type: EMAIL_DESIGNER.SET_ESP_USER_CREDIT,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    }
  } catch (error) {
    console.log("error", error.response);
    console.log(typeof error);
  }
};

export function listSendFileValidation(clientId, templateId, fieldName, file, recipientColumn, originalRowCount, duplicatesRemoved) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + `ESP/Email/ValidateListSend?clientId=${clientId}&templateId=${templateId}&recipientColumn=${encodeURIComponent(recipientColumn)}&originalRowCount=${originalRowCount || 0}&duplicatesRemoved=${duplicatesRemoved || 0}`;
      let formData = new FormData();
      formData.append('file', file);

      const response = await axios.post(URL, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      dispatch({
        type: EMAIL_DESIGNER.LIST_SEND_FILE_VALIDATION,
        payload: response.data
      });
      return response.data;
    } catch (error) {
      console.log("error", error);
      return error;
    }
  };
}

export function resetListSendFileValidation() {
  return async function (dispatch) {
    try {
      dispatch({
        type: EMAIL_DESIGNER.LIST_SEND_FILE_VALIDATION,
        payload: null
      });
    } catch (error) {
      console.log("error", error);
      return error;
    }
  };
}

export function sendEmailListSend(clientId, data, columnMappings, respectCDPPermissions, recipientColumnName, processedFilePath) {
  return async function (dispatch) {
    try {
      // Validate that processedFilePath is provided
      if (!processedFilePath) {
        console.error('ProcessedFilePath is required for sendEmailListSend');
        dispatch({
          type: EMAIL_DESIGNER.SEND_EMAIL,
          payload: {
            operationSuccessful: false,
            messages: [{
              messageTypeId: 2,
              messageContent: 'ProcessedFilePath is required. Please validate the file first.'
            }]
          }
        });
        return;
      }

      let formData = new FormData();
      // Add other data fields to the FormData object
      Object.keys(data).forEach((key) => {
        if (data[key] && key !== "TrackingParamsList") {
          formData.append(key, data[key]);
        }
      });

      // Add the processed file path from validation (required)
      formData.append('processedFilePath', processedFilePath);

      // Add mapping and permissions data
      if (columnMappings) {
        formData.append('columnMappings', JSON.stringify(columnMappings));
      }
      formData.append('respectCDPPermissions', respectCDPPermissions);
      if (recipientColumnName) {
        formData.append('recipientColumnName', recipientColumnName);
      }

      let URL = Constants.VNEXT_BASE_URL + "ESP/Email/SendEmailListSend?clientId=" + clientId;

      const response = await axios.post(URL, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      dispatch({
        type: EMAIL_DESIGNER.SEND_EMAIL,
        payload: response.data,
      });
      return response.data;
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function enableWebhookTriggerEmail(clientId, data, DataConfigId) {
  return async function (dispatch) {
    try {
      let formData = new FormData();
      // Add other data fields to the FormData object
      Object.keys(data).forEach((key) => {
        if (data[key] && key !== "TrackingParamsList") {
          formData.append(key, data[key]);
        }
      });
      let URL = Constants.VNEXT_BASE_URL + "ESP/Email/EnableWebhookTriggerEmail?clientId=" + clientId + "&DataConfigID=" + DataConfigId;
      const response = await axios.post(URL, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      dispatch({
        type: EMAIL_DESIGNER.ENABLE_WEBHOOK_TRIGGER,
        payload: response.data,
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getWebhookUrl(clientId, dataConfigId, webhookID) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Email/GetWebhookUrl?clientId=" +
        clientId + "&dataConfigId=" + dataConfigId + "&webhookID=" + webhookID;

      const response = await axios.get(URL);
      const test = "";
      dispatch({
        type: EMAIL_DESIGNER.GET_WEBHOOK_URL,
        payload: response.data,
      });
      return response.data;
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function updateWebHookStatus(clientId, webhookDataID, status) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Email/UpdateWebhookDataStatus?clientId=" +
        clientId + "&webhookDataID=" + webhookDataID + "&status=" + status;

      const response = await axios.get(URL);
      response.data.content = response.data.operationSuccessful
      return response.data;
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function resendWebhookPayload(clientId, webhookDataId, webhookConfigId) {
  return async function (dispatch) {
    try {
      let URL = `${Constants.VNEXT_BASE_URL}ESP/Design/ResendWebhookPayload?clientId=${clientId}&webhookDataId=${webhookDataId}&webhookConfigId=${webhookConfigId}`;
      const response = await axios.post(URL);
      return response.data;
    } catch (error) {
      console.log("error", error.response);
    }
  };
}

export function getEspUsers(clientId) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + "ESP/Email/GetEspUsers?clientId=" + clientId; 

      const response = await axios.get(URL);
      return response.data.content;
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getAllMergeTagsFromDesign(clientId, templateId) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + 'ESP/Email/GetAllMergeTagsFromDesign?clientId=' + clientId + "&templateId=" + templateId;

      const response = await axios.get(URL);
      // const responseData = HelperFunctions.responseHandlerVNext(response.data);
      const responseData = response.data;
      dispatch({
        type: EMAIL_DESIGNER.GET_ALL_MERGE_TAGS_FROM_DESIGN,
        payload: responseData
      });
      return responseData;
    } catch (error) {
      console.log("error", error);
    }
  };
}


export function getDesignPreview(partitionKey) {
  return async function (dispatch) {
    try {
      dispatch({
        type: EMAIL_DESIGNER.GET_DESIGN_PREVIEW,
        payload: { loading: true, error: false }
      });

      const URL = `${Constants.VNEXT_BASE_URL}ESP/Bee/GetDesignPreview/${partitionKey}`;
      const response = await axios.get(URL);
      const result = HelperFunctions.responseHandlerVNext(response.data);

      if(result?.length === 0){
        dispatch({
          type: EMAIL_DESIGNER.GET_DESIGN_PREVIEW_ERROR,
          payload: { loading: false, error: true }
        });
        return;
      }

      dispatch({
        type: EMAIL_DESIGNER.GET_DESIGN_PREVIEW_SUCCESS,
        payload: {
          designName: result.designName,
          beeAuthResponse: result.beeAuthResponse,
          json: result.json,
          html: result.html,
          loading: false,
          error: false
        }
      });

      return result;
    } catch (error) {
      console.error("getDesignPreview error:", error);
      dispatch({
        type: EMAIL_DESIGNER.GET_DESIGN_PREVIEW_ERROR,
        payload: { loading: false, error: true }
      });
      throw error;
    }
  };
}

export function getDesignIdByPartitionKey(partitionKey) {
  return async function (dispatch) {
    try {
      const URL = `${Constants.VNEXT_BASE_URL}/ESP/Bee/GetDesignIdByPartitionKey/${partitionKey}`;
      const response = await axios.get(URL);
      
      dispatch({
        type: EMAIL_DESIGNER.GET_DESIGN_ID_BY_PARTITION,
        payload: response.data
      });

      return response.data;
    } catch (error) {
      console.error("getDesignIdByPartitionKey error:", error);
      throw error;
    }
  };
}

export function generatePublicPreviewLink(clientId, designId) {
  return async function (dispatch) {
    try {
      dispatch({
        type: EMAIL_DESIGNER.GENERATE_PUBLIC_PREVIEW_LINK,
        payload: { isGeneratingLink: true }
      });

      const response = await axios.post(
        `${import.meta.env.VITE_VNEXT_BASE_URL}api/ESP/Bee/GeneratePublicPreviewLink`,
        {
          clientId: clientId,
          designId: designId
        },
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }
      );
      
      const result = response.data;
      
      if (result.operationSuccessful) {
        const publicPreviewLink = `${import.meta.env.VITE_BASE_URL}${result.content}`;
        dispatch({
          type: EMAIL_DESIGNER.GENERATE_PUBLIC_PREVIEW_LINK_SUCCESS,
          payload: { 
            publicPreviewLink,
            isGeneratingLink: false 
          }
        });
        return { success: true, link: publicPreviewLink };
      } else {
        dispatch({
          type: EMAIL_DESIGNER.GENERATE_PUBLIC_PREVIEW_LINK_ERROR,
          payload: { isGeneratingLink: false, error: "Failed to generate preview link" }
        });
        return { success: false, error: "Failed to generate preview link" };
      }
    } catch (error) {
      console.error("Error generating preview link:", error);
      dispatch({
        type: EMAIL_DESIGNER.GENERATE_PUBLIC_PREVIEW_LINK_ERROR,
        payload: { isGeneratingLink: false, error: "Failed to generate preview link" }
      });
      return { success: false, error: "Failed to generate preview link" };
    }
  };
}

export function revokePublicPreviewLink(clientId, designId) {
  return async function (dispatch) {
    try {
      dispatch({
        type: EMAIL_DESIGNER.REVOKE_PUBLIC_PREVIEW_LINK,
        payload: { isRevokingLink: true }
      });

      const response = await axios.post(
        `${import.meta.env.VITE_VNEXT_BASE_URL}api/ESP/Bee/RevokePublicPreviewLink`,
        {
          clientId: clientId,
          designId: designId
        },
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }
      );
      
      const result = response.data;
      
      if (result.operationSuccessful) {
        dispatch({
          type: EMAIL_DESIGNER.REVOKE_PUBLIC_PREVIEW_LINK_SUCCESS,
          payload: { 
            publicPreviewLink: "",
            isRevokingLink: false,
            showRevokeConfirm: false
          }
        });
        return { success: true, message: "Preview link revoked successfully" };
      } else {
        dispatch({
          type: EMAIL_DESIGNER.REVOKE_PUBLIC_PREVIEW_LINK_ERROR,
          payload: { 
            isRevokingLink: false,
            showRevokeConfirm: false,
            error: "Failed to revoke preview link"
          }
        });
        return { success: false, error: "Failed to revoke preview link" };
      }
    } catch (error) {
      console.error("Error revoking preview link:", error);
      dispatch({
        type: EMAIL_DESIGNER.REVOKE_PUBLIC_PREVIEW_LINK_ERROR,
        payload: { 
          isRevokingLink: false,
          showRevokeConfirm: false,
          error: "Failed to revoke preview link"
        }
      });
      return { success: false, error: "Failed to revoke preview link" };
    }
  };
}

export function getPublicPreviewLink(clientId, designId) {
  return async function (dispatch) {
    try {
      const response = await axios.get(
        `${import.meta.env.VITE_VNEXT_BASE_URL}api/ESP/Bee/GetPublicPreviewLink`,
        {
          params: {
            clientId: clientId,
            designId: designId
          }
        }
      );
      
      const result = response.data;
      
      if (result.operationSuccessful && result.content) {
        const publicPreviewLink = `${import.meta.env.VITE_BASE_URL}${result.content}`;
        dispatch({
          type: EMAIL_DESIGNER.GET_PUBLIC_PREVIEW_LINK_SUCCESS,
          payload: { publicPreviewLink }
        });
        return { success: true, link: publicPreviewLink };
      } else {
        dispatch({
          type: EMAIL_DESIGNER.GET_PUBLIC_PREVIEW_LINK_SUCCESS,
          payload: { publicPreviewLink: "" }
        });
        return { success: true, link: "" };
      }
    } catch (error) {
      // A 400 means the design has no preview link yet — treat as "no link" rather than a true error
      if (error?.response?.status === 400) {
        dispatch({
          type: EMAIL_DESIGNER.GET_PUBLIC_PREVIEW_LINK_SUCCESS,
          payload: { publicPreviewLink: "" }
        });
        return { success: true, link: "" };
      }
      console.error("Error checking existing preview link:", error);
      dispatch({
        type: EMAIL_DESIGNER.GET_PUBLIC_PREVIEW_LINK_ERROR,
        payload: { publicPreviewLink: "", error: "Failed to get preview link" }
      });
      return { success: false, error: "Failed to get preview link" };
    }
  };
}

export function clearPublicPreviewLink() {
  return {
    type: EMAIL_DESIGNER.CLEAR_PUBLIC_PREVIEW_LINK,
    payload: {
      publicPreviewLink: "",
      isGeneratingLink: false,
      isRevokingLink: false,
      showRevokeConfirm: false
    }
  };
}

export function clearDesignPreview() {
  return {
    type: EMAIL_DESIGNER.CLEAR_DESIGN_PREVIEW,
    payload: null
  };
}

export function ExportEmailDesignHtml(clientId, designId, designName) {
  return async function () {
    try {
      const url = `${Constants.VNEXT_BASE_URL}ESP/Design/ExportHtml?clientId=${clientId}&designId=${designId}`;

      const timestamp = new Date()
        .toISOString()
        .replace(/[-:T]/g, (c) => (c === "T" ? "-" : c === ":" ? "" : c))
        .slice(0, 15);
      const sanitizedName = (designName || "design")
        .replace(/[^a-zA-Z0-9\s-]/g, "")
        .trim()
        .replace(/\s+/g, "-")
        .toLowerCase();
      const fileName = `${sanitizedName}-${timestamp}.html`;

      await downloadFileV2(url, fileName);
      return { success: true };
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to export HTML.";
      return { success: false, error: message };
    }
  };
}


/**
 * Runs Bee Check against a template JSON to identify design issues.
 * Calls the backend API which proxies to Bee Content Services API.
 * @param {string} templateJson - The template JSON string to check
 * @param {string} checkType - "message" for Email or "page" for Page/Landing Page
 * @returns {Function} Redux thunk action
 */
export function runBeeCheck(templateJson, checkType = "message") {
  return async function (dispatch) {
    try {
      dispatch({ type: EMAIL_DESIGNER.BEE_CHECK_REQUEST });

      const URL = `${Constants.VNEXT_BASE_URL}ESP/Bee/CheckDesign`;

      const response = await axios({
        method: "post",
        url: URL,
        data: {
          templateJson: templateJson,
          checkType: checkType
        },
      });

      const result = response.data;

      if (result.operationSuccessful) {
        const checkResults = typeof result.content === "string"
          ? JSON.parse(result.content)
          : result.content;

        dispatch({
          type: EMAIL_DESIGNER.BEE_CHECK_SUCCESS,
          payload: checkResults,
        });

        return { success: true, data: checkResults };
      } else {
        const errorMsg = result.messages?.[0]?.messageContent || "Check failed";
        dispatch({
          type: EMAIL_DESIGNER.BEE_CHECK_ERROR,
          payload: errorMsg,
        });
        return { success: false, error: errorMsg };
      }
    } catch (error) {
      console.error("Bee Check error:", error);
      dispatch({
        type: EMAIL_DESIGNER.BEE_CHECK_ERROR,
        payload: error.message || "Failed to run design check",
      });
      return { success: false, error: error.message };
    }
  };
}

/**
 * Clears the Bee Check results from the store.
 */
export function clearBeeCheck() {
  return {
    type: EMAIL_DESIGNER.BEE_CHECK_CLEAR,
  };
}

/**
 * Applies the client's current Content Defaults to an existing email design JSON via
 * BEE's Brand Style Management endpoint (proxied through our backend). Block content
 * (text, image src, link href, etc.) is preserved by BEE; only block styling is overwritten.
 *
 * Backend already crafts the user-facing message — including the AC #9 "no matching blocks"
 * text for BEE's 422 response — so callers can surface `result.error` verbatim in a toast.
 *
 * @param {number} clientId
 * @param {string} templateJson - The current design JSON as a string (from latestTemplateJsonRef)
 * @returns {Promise<{success: boolean, templateJson?: object, error?: string}>}
 */
export async function applyBrandStyle(clientId, templateJson) {
  try {
    const URL = `${Constants.VNEXT_BASE_URL}ESP/Bee/ApplyBrandStyle?clientId=${clientId}`;
    const response = await axios.post(URL, { templateJson });
    const result = response.data;

    if (result.operationSuccessful) {
      const restyled = typeof result.content === "string"
        ? JSON.parse(result.content)
        : result.content;
      return { success: true, templateJson: restyled };
    }

    const errorMsg = result.messages?.[0]?.messageContent || "Failed to apply Content Defaults.";
    return { success: false, error: errorMsg };
  } catch (error) {
    console.error("Apply Brand Style error:", error);
    return { success: false, error: error.message || "Failed to apply Content Defaults." };
  }
}
